

<template>
    <section class="px-0 py-3 br-top">
        <div class="container">
            <div class="row">
                <div v-for="(item, index) in footerTopData" :key="index" class="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                    <div class="d-flex align-items-center justify-content-start py-2">
                        <div class="d_ico">
                            <i class="theme-cl" :class="item.icon"></i>
                        </div>
                        <div class="d_capt">
                            <h5 class="mb-0">{{item.title}}</h5>
                            <span class="text-muted">{{item.desc}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { footerTopData } from '@/data/data';
</script>
